<template>
  <div class="frame">
    <div style="padding: 50px 5%; overflow: hidden; width: 90%">
      <div v-if="activityInfo.contentType == 1">
        <img :src="activityInfo.landingImgPc" alt />
      </div>
      <div
        v-if="activityInfo.contentType == 2"
        v-html="activityInfo.landingHtmlPc"
      ></div>
    </div>
    <div class="qrcode" slot="content">
      <div v-if="getBuyLink(actId)">
        <p>扫码购买</p>
        <qrcode-vue
          :value="getBuyLink(actId)"
          :size="200"
          level="H"
        ></qrcode-vue>
      </div>
      <div v-else style="height: 200px; width: 180px">
        <br /><br />
        <h3>请注册用户后购买</h3>
        <br /><br />
        <router-link
          style="
            font-size: 20px;
            background: #39a5ef;
            display: inline-block;
            border-radius: 30px;
            line-height: 30px;
            padding: 5px 36px;
          "
          to="/register"
          >前往注册</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "@/utils/auth";
import { getActivityDetail, getBuyLink } from "@/api/buy";
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    QrcodeVue,
  },
  data() {
    return {
      actId: "",
      userId: "",
      userInfo: {},
      activityInfo: {},
    };
  },
  mounted() {
    this.actId = this.$route.query.actId;
    // this.userId = this.$route.query.userId;
    this.userInfo = JSON.parse(getUserInfo());
    if (this.userInfo == null) {
      this.$Message.info("未登录");
    } else {
      this.userId = this.userInfo.id;
    }
    this.getActivityInfo();
  },
  methods: {
    getActivityInfo() {
      getActivityDetail(this.actId).then((res) => {
        this.activityInfo = res.result;
        window.document.title =
          this.activityInfo.landingTitle || this.activityInfo.activityName;
      });
    },
    getBuyLink(id) {
      return getBuyLink(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.qrcode {
  position: fixed;
  right: 10px;
  bottom: 10px;
  background: white;
  padding: 10px;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/my/goodsDetail.vue